import { createAsyncTypes } from 'utils/ActionCreator'

export const PARTNER_COMPANIES_GET_ASYNC = createAsyncTypes(
  'PARTNER_COMPANIES_GET_ASYNC',
  'Partner'
)

export const NEW_COMPANY_ADD_ASYNC = createAsyncTypes('NEW_COMPANY_ADD_ASYNC', 'Partner')
export const NEW_COMPANY_RESET_MESSAGE = 'Partner/NEW_COMPANY_RESET_MESSAGE'

export const PARTNER_INCIDENTS_GET_ASYNC = createAsyncTypes(
  'PARTNER_INCIDENTS_GET_ASYNC',
  'Partner'
)
export const PARTNER_STATISTICS_GET_ASYNC = createAsyncTypes(
  'PARTNER_STATISTICS_GET_ASYNC',
  'Partner'
)
export const PARTNER_SUCCESS_SUBMISSION_SEND_ASYNC = createAsyncTypes(
  'PARTNER_SUCCESS_SUBMISSION_SEND_ASYNC',
  'Partner'
)

export const MIGRATE_COMPANY_ASYNC = createAsyncTypes('MIGRATE_COMPANY_ASYNC', 'Partner')

export const FETCH_POSSIBLE_ACQUIRING_PARTNERS_ASYNC = createAsyncTypes(
  'FETCH_POSSIBLE_ACQUIRING_PARTNERS',
  'Partner'
)

export const INCIDENTS_FILTER_CHANGE = 'Partner/INCIDENTS_FILTER_CHANGE'

export const COMPANIES_PAGE_CHANGE = 'Partner/COMPANIES_PAGE_CHANGE'
export const COMPANIES_FILTER_CHANGE = 'Partner/COMPANIES_FILTER_CHANGE'
export const SEARCH_CHANGE = 'Partner/SEARCH_CHANGE'
export const SEARCH_RESET = 'Partner/SEARCH_RESET'

export const SORT_PROPERTY_CHANGE = 'Partner/SORT_PROPERTY_CHANGE'

export const integrationByTypeMap = {
  o365: 'office365',
  gmail_webhooks: 'google-workspace',
  gmail_serverside: 'google-workspace',
  exchange: 'exchange',
}

export const COMPANY_FILTER_OPTIONS = {
  ALL_COMPANIES: 'all',
  ACTIVE_COMPANIES: 'active',
  PENDING_RENEWAL: 'renewal',
  TRIAL_COMPANIES: 'trial',
  EXPIRED_COMPANIES: 'expired',
  UPSELL_COMPANIES: 'upsell',
  UNPROTECTED_COMPANIES: 'unprotected',
  INACTIVE_INTEGRATION: 'inactiveIntegrations',
  REINTEGRATION_REQUIRED: 'reintegrationRequired',
}
